import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// FontAwesome
import { faPaw } from '@fortawesome/free-solid-svg-icons/faPaw';

const canStepOnCss = css`
	background: #c3baff;
    cursor: pointer;
`;

const canStepOnCssHover = css`
    &&:hover {
		cursor: pointer;
		background: #c3ba00;
    }
`;

const steppedCss = css`
	background: #908cff;
	&&:hover {
		background: #908cff;
		cursor: auto;
		transform: none;
	}
`;

const destroyableCss = css`
	// TODO
`;

const BoardSquare = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-around;
	color: white;
	background: white;
    font-weight: bold;
    font-size: 1.5em;
    text-align: center;
    flex: 1 0 auto;
    border: 1px solid #eee;
    margin: -1px;
    transition: all 0.35s;
	width: ${props => (props.squareLength <= 60 ? `${props.squareLength}px` : '60px')};
	height: ${props => (props.squareLength <= 60 ? `${props.squareLength}px` : '60px')};

	${props => (props.canStepOn ? canStepOnCssHover : '')};

    ${props => props.canStepOn && canStepOnCss};
    ${props => props.stepped && steppedCss};
    ${props => props.destroyable && destroyableCss};
`;

const CatPawIcon = styled(FontAwesomeIcon)`
	font-size: 20px;
	color: white;
`;

const Field = (props) => {
	const {
		squareLength,
		canStepOn,
		stepped,
		destroyable,
		current,
		onClick,
		onMouseEnter,
		onMouseLeave,
	} = props;

	return (
		<BoardSquare
			squareLength={squareLength}
			onClick={onClick}
			onMouseEnter={onMouseEnter}
			onMouseLeave={onMouseLeave}
			canStepOn={canStepOn}
			stepped={stepped}
			destroyable={destroyable}
		>
			{current && <CatPawIcon icon={faPaw} />}
		</BoardSquare>
	);
};

Field.propTypes = {
	squareLength: PropTypes.number,
	canStepOn: PropTypes.bool.isRequired,
	stepped: PropTypes.bool,
	onClick: PropTypes.func.isRequired,
	onMouseEnter: PropTypes.func,
	onMouseLeave: PropTypes.func,
	current: PropTypes.bool,
	destroyable: PropTypes.bool,
};

Field.defaultProps = {
	squareLength: 60,
	stepped: false,
	destroyable: false,
	current: false,
	onMouseEnter: () => {},
	onMouseLeave: () => {},
};

export default Field;
